interface GetNavigationElementIsActiveProps {
  href?: string;
  pathname: string;
}

export const getNavigationElementIsActive = ({
  href,
  pathname,
}: GetNavigationElementIsActiveProps) => {
  if (!href) return false;

  // Homepage href is '/' so we need to check if the pathname is exactly '/' otherwise it will always be active
  if (href.length === 1) return href === pathname;

  return pathname.startsWith(href);
};
